import { render, staticRenderFns } from "./EmptyStateList.vue?vue&type=template&id=40b283aa&scoped=true&"
import script from "./EmptyStateList.vue?vue&type=script&lang=ts&"
export * from "./EmptyStateList.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyStateList.vue?vue&type=style&index=0&id=40b283aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b283aa",
  null
  
)

export default component.exports